import 'core-js/stable';
import { initNavSearch } from './nav-search'
import React from 'react';
import ReactDOM from 'react-dom'
/* 
If using the old gameday api, uncomment this and comment out the other clubfinder component
import ClubFinder from './gameday-club-finder/ClubFinder'*/

/* 
If using the new PlayHQ api, uncomment this and comment out the other clubfinder component */
import ClubFinder from './club-finder/ClubFinder'

/**
Javascript entry point for pages that use the map finder component
*/
const mapEl = document.getElementById('map_locator');

if (mapEl){
  initNavSearch();
  ReactDOM.render(
    <ClubFinder />,
    mapEl
  ); 
}


